module.exports = new __parcel__URL__("statuspage-right.447da08b.svg").toString();